import React from "react";
import dayjs from 'dayjs';
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
import { useState, useEffect } from 'react';
import { all_routes } from "../../../Router/all_routes";
import { base_api_url } from "../../../environment.jsx";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import PropTypes from 'prop-types';


const AddTables = ({ onFormSubmit, show, onClose, editMode = false, TableData = null, defaultType = 1 }) => {
    const MySwal = withReactContent(Swal);
    const ideresto = JSON.parse(localStorage.getItem("user"))?.restoId;
    const route = all_routes;
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const restaurantInfo = JSON.parse(localStorage.getItem("restaurant") || "{}");
    const restaurantName = restaurantInfo?.restaurant?.nom || "Mon Restaurant";

    //pour recuprer les elements du formulaire
    const prefixParDefaut = defaultType === 2 ? 'VAD' : defaultType === 3 ? 'Client' : 'Table';
    const [formData, setFormData] = useState({
        "prefix_nom": prefixParDefaut,
        "id_restaurant": ideresto,
        "capacite": 4,
        "type_table": defaultType,
    });
    const [nbTables, setNbTables] = useState(1);

    // Use Effect pour populate le formulaire en mode édition
    useEffect(() => {
        if (editMode && TableData) {
            console.log("Auto-populating form with menu data:", TableData);
            setFormData({
                prefix_nom: TableData.numero_table?.replace(/\d+$/, '') || 'Table',
                capacite: TableData.capacite || 4,
                id_restaurant: ideresto,
                type_table: TableData.type_table || defaultType,
            });
            setNbTables(1);
        } else {
            const pref = defaultType === 2 ? 'VAD' : defaultType === 3 ? 'Client' : 'Table';
            setFormData({
                "prefix_nom": pref,
                "id_restaurant": ideresto,
                "capacite": 4,
                "type_table": defaultType,
            });
            setNbTables(1);
        }
    }, [editMode, TableData, ideresto, show, defaultType]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'capacite') {
            setFormData((prevData) => ({
                ...prevData,
                [name]: parseInt(value) || 0, // Convertir en entier ou 0 si invalide
            }));
        } else if (name === 'type_table') {
            setFormData((prevData) => ({
                ...prevData,
                [name]: parseInt(value), // Convertir en entier
            }));
        } else {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };
    // const resetForm = () => {
    //     setFormData({
    //         numero_table: "",
    //         capacite: 4,
    //         type_table: 1, // Default to Classique
    //     });
    //     setNbTables(1);
    // };
    // pour la soumission du formulaire
    const handleSubmit = async (e) => {
        e.preventDefault(); // éviter le rechargement de la page
        setLoading(true);
        try {
            const token = JSON.parse(localStorage.getItem("user"))?.access_token;
            console.log(token)
            let response;
            console.log(formData)

            if (editMode && TableData?.code_qr) {
                // Mode édition : utiliser l'ancien endpoint PUT pour une seule table
                const formDatatoSubmit = {
                    numero_table: formData.prefix_nom, // En mode édition, prefix_nom devient numero_table
                    capacite: parseInt(formData.capacite) || 0,
                    type_table: parseInt(formData.type_table) || 1,
                    id_restaurant: ideresto,
                };

                response = await axios.put(`${base_api_url}api/tables/${TableData.code_qr}`,
                    formDatatoSubmit,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${token}`,
                        },
                    });
            } else {
                // Mode création : utiliser le nouveau endpoint de création en masse
                const massCreationData = {
                    prefix_nom: formData.prefix_nom || "Table",
                    capacite: parseInt(formData.capacite) || 4,
                    type_table: parseInt(formData.type_table) || 1,
                    id_restaurant: ideresto,
                    nbr_table: parseInt(nbTables) || 1,
                };

                console.log("Mass creation data:", massCreationData);

                response = await axios.post(`${base_api_url}api/tables_mass`,
                    massCreationData,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${token}`,
                        },
                    });
            }

            console.log(response)
            console.log("Réponse API :", response.data);

            // Handle successful responses (200, 201)
            if (response.status === 200 || response.status === 201) {
                const tablesCreated = response.data?.tables?.length || 0;
                const successMessage = editMode
                    ? "La table a été modifiée avec succès."
                    : response.data?.message || `${tablesCreated} table(s) créée(s) avec succès.`;

                // Show success toast
                MySwal.fire({
                    icon: "success",
                    text: successMessage,
                    toast: true,
                    position: "bottom-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    customClass: {
                        popup: "pixel-toast",
                    },
                });

                // Close modal first
                onClose();

                // Call onFormSubmit after successful operation
                if (onFormSubmit) {
                    onFormSubmit();
                }
            }

        } catch (error) {
            console.log("Error details:", error.response?.data || error.message);

            //             let errorTitle = "Erreur";
            let errorMessage = "Une erreur s'est produite. Veuillez réessayer.";

            if (error.response) {
                const status = error.response.status;
                const errorData = error.response.data;

                switch (status) {
                    case 400:
                        //                         errorTitle = "Données invalides";
                        if (errorData?.message?.includes("numero_table")) {
                            errorMessage = "Le numéro de table est requis et ne peut pas être vide.";
                        } else if (errorData?.message?.includes("capacite")) {
                            errorMessage = "La capacité est requise et doit être un nombre valide.";
                        } else {
                            errorMessage = errorData?.message || "Les données saisies ne sont pas valides. Vérifiez que tous les champs requis sont remplis correctement.";
                        }
                        break;

                    case 401:
                        //                         errorTitle = "Accès non autorisé";
                        errorMessage = "Votre session a expiré. Veuillez vous reconnecter pour continuer.";
                        setTimeout(() => {
                            navigate(route.signin);
                        }, 2000);
                        break;

                    case 402: {
                        //                         errorTitle = "Champs requis manquants";
                        const missingFields = [];
                        if (!formData.numero_table || formData.numero_table.trim() === "") missingFields.push("numéro de table");
                        if (!formData.capacite || formData.capacite <= 0) missingFields.push("capacité");

                        if (missingFields.length > 0) {
                            errorMessage = `Les champs suivants sont requis : ${missingFields.join(", ")}.`;
                        } else {
                            errorMessage = "Veuillez remplir tous les champs obligatoires.";
                        }
                        break;
                    }

                    case 404:
                        //                         errorTitle = editMode ? "Table introuvable" : "Ressource introuvable";
                        errorMessage = editMode
                            ? "La table que vous tentez de modifier n'existe plus ou a été supprimée."
                            : "La ressource demandée est introuvable. Veuillez actualiser la page et réessayer.";
                        break;

                    case 409:
                        //                         errorTitle = "Table déjà existante";
                        errorMessage = "Une table avec ce numéro existe déjà. Veuillez choisir un numéro différent.";
                        break;

                    case 422:
                        //                         errorTitle = "Données non valides";
                        errorMessage = errorData?.message || "Les données saisies ne respectent pas le format requis.";
                        break;

                    case 500:
                        //                         errorTitle = "Erreur du serveur";
                        errorMessage = "Une erreur s'est produite sur le serveur. Veuillez réessayer dans quelques instants.";
                        break;

                    case 503:
                        //                         errorTitle = "Service temporairement indisponible";
                        errorMessage = "Le service est temporairement indisponible. Veuillez réessayer dans quelques minutes.";
                        break;

                    default:
                        //                         errorTitle = `Erreur ${status}`;
                        errorMessage = errorData?.message || `Une erreur inattendue s'est produite (Code: ${status}).`;
                }
            } else if (error.request) {
                //                 errorTitle = "Problème de connexion";
                errorMessage = "Impossible de contacter le serveur. Vérifiez votre connexion internet et réessayez.";
            }

            // Show error toast
            MySwal.fire({
                icon: "error",
                // title: errorTitle,
                text: errorMessage,
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 5000, // Longer timer for error messages
                timerProgressBar: true,
                customClass: {
                    popup: "pixel-toast",
                },
            });
        } finally {
            setLoading(false);
        }
    };
    if (!show) return null;

    /* ── Helpers éléments communs ──────────────────────────── */
    const ModalWrapper = ({ children }) => (
        <>
            <div onClick={onClose} style={{ position:'fixed', inset:0, backgroundColor:'rgba(0,0,0,0.35)', backdropFilter:'blur(4px)', zIndex:1040 }} />
            <div style={{ position:'fixed', top:'50%', left:'50%', transform:'translate(-50%,-50%)', width:'480px', maxWidth:'94vw', backgroundColor:'#fff', borderRadius:'20px', boxShadow:'0 20px 60px rgba(0,0,0,0.18)', zIndex:1050, overflow:'hidden' }}>
                <form onSubmit={handleSubmit}>
                    {/* Header */}
                    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'28px 28px 20px 28px', borderBottom:'1px solid #f3f4f6' }}>
                        <h5 style={{ margin:0, fontSize:'20px', fontWeight:700, color:'#111827' }}>Ajouter</h5>
                        <button type="button" onClick={onClose} style={{ background:'none', border:'none', fontSize:'22px', color:'#9ca3af', cursor:'pointer', lineHeight:1, padding:0 }}>×</button>
                    </div>
                    {/* Body */}
                    <div style={{ padding:'24px 28px' }}>
                        {children}
                    </div>
                    {/* Footer */}
                    <div style={{ padding:'0 28px 28px 28px', display:'flex', flexDirection:'column', gap:'10px' }}>
                        <button type="submit" disabled={loading} style={{ width:'100%', height:'52px', backgroundColor:'#ff6b35', border:'none', borderRadius:'12px', color:'#fff', fontWeight:700, fontSize:'15px', cursor:loading?'not-allowed':'pointer', opacity:loading?0.7:1, display:'flex', alignItems:'center', justifyContent:'center', gap:'8px', transition:'background 0.15s' }}>
                            {loading && <span className="spinner-border spinner-border-sm" style={{ width:'14px', height:'14px', borderWidth:'2px' }} />}
                            Ajouter
                        </button>
                        <button type="button" onClick={onClose} style={{ width:'100%', height:'52px', backgroundColor:'#fff', border:'1px solid #e5e7eb', borderRadius:'12px', color:'#374151', fontWeight:500, fontSize:'15px', cursor:'pointer', transition:'background 0.15s' }}>Annuler</button>
                    </div>
                </form>
            </div>
        </>
    );

    ModalWrapper.propTypes = {
        children: PropTypes.node.isRequired
    };

    const Counter = ({ label, value, onDec, onInc }) => (
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'20px' }}>
            <label style={{ fontSize:'14px', color:'#374151', fontWeight:400, margin:0 }}>{label}</label>
            <div style={{ display:'flex', alignItems:'center' }}>
                <button type="button" onClick={onDec} style={{ width:'40px', height:'40px', border:'1px solid #e5e7eb', borderRadius:'8px 0 0 8px', background:'#fff', color:'#374151', fontSize:'18px', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>−</button>
                <div style={{ width:'48px', height:'40px', border:'1px solid #e5e7eb', borderLeft:'none', borderRight:'none', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:600, fontSize:'16px', color:'#111827' }}>{value}</div>
                <button type="button" onClick={onInc} style={{ width:'40px', height:'40px', border:'1px solid #e5e7eb', borderRadius:'0 8px 8px 0', background:'#fff', color:'#374151', fontSize:'18px', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>+</button>
            </div>
        </div>
    );

    Counter.propTypes = {
        label: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        onDec: PropTypes.func.isRequired,
        onInc: PropTypes.func.isRequired
    };

    /* ── Type 1 : Table classique ────────────────────────── */
    if (defaultType === 1 && !editMode) {
        return (
            <ModalWrapper>
                <Counter label="Nombre de tables" value={nbTables}
                    onDec={() => setNbTables(Math.max(1, nbTables-1))}
                    onInc={() => setNbTables(nbTables+1)} />
                <Counter label="Capacité par table" value={formData.capacite}
                    onDec={() => setFormData(p => ({ ...p, capacite: Math.max(1, p.capacite-1) }))}
                    onInc={() => setFormData(p => ({ ...p, capacite: p.capacite+1 }))} />
                {/* Préfixe readonly */}
                <div style={{ marginBottom:'20px' }}>
                    <label style={{ display:'block', fontSize:'11px', fontWeight:700, letterSpacing:'0.08em', color:'#374151', marginBottom:'8px', textTransform:'uppercase' }}>Préfixe</label>
                    <input type="text" value="Table" readOnly style={{ width:'100%', height:'48px', border:'1px solid #e5e7eb', borderRadius:'10px', fontSize:'15px', color:'#111827', padding:'0 14px', backgroundColor:'#fff', cursor:'default', outline:'none' }} />
                </div>
                {/* Radio Classique pré-sélectionné */}
                <label style={{ display:'flex', alignItems:'center', padding:'14px 16px', border:'2px solid #ff6a3d', borderRadius:'10px', backgroundColor:'#fff4f0', cursor:'default', marginTop:'4px' }}>
                    <span style={{ width:'18px', height:'18px', borderRadius:'50%', border:'2px solid #ff6a3d', display:'flex', alignItems:'center', justifyContent:'center', marginRight:'12px', flexShrink:0 }}>
                        <span style={{ width:'8px', height:'8px', borderRadius:'50%', backgroundColor:'#ff6a3d', display:'block' }} />
                    </span>
                    <div>
                        <div style={{ fontSize:'14px', fontWeight:600, color:'#ff6a3d', marginBottom:'2px' }}>Classique</div>
                        <div style={{ fontSize:'12px', color:'#6b7280' }}>Format standard pour la salle</div>
                    </div>
                </label>
            </ModalWrapper>
        );
    }

    /* ── Type 3 : QR Client ──────────────────────────────── */
    if (defaultType === 3 && !editMode) {
        return (
            <ModalWrapper>
                <Counter label="Nombre de QR Clients" value={nbTables}
                    onDec={() => setNbTables(Math.max(1, nbTables-1))}
                    onInc={() => setNbTables(nbTables+1)} />
                {/* Préfixe readonly */}
                <div style={{ marginBottom:'20px' }}>
                    <label style={{ display:'block', fontSize:'11px', fontWeight:700, letterSpacing:'0.08em', color:'#374151', marginBottom:'8px', textTransform:'uppercase' }}>Préfixe</label>
                    <input type="text" value="Client" readOnly style={{ width:'100%', height:'48px', border:'1px solid #e5e7eb', borderRadius:'10px', fontSize:'15px', color:'#111827', padding:'0 14px', backgroundColor:'#fff', cursor:'default', outline:'none' }} />
                </div>
                {/* Radio QR Code Client pré-sélectionné */}
                <label style={{ display:'flex', alignItems:'center', padding:'14px 16px', border:'2px solid #ff6a3d', borderRadius:'10px', backgroundColor:'#fff4f0', cursor:'default' }}>
                    <span style={{ width:'18px', height:'18px', borderRadius:'50%', border:'2px solid #ff6a3d', display:'flex', alignItems:'center', justifyContent:'center', marginRight:'12px', flexShrink:0 }}>
                        <span style={{ width:'8px', height:'8px', borderRadius:'50%', backgroundColor:'#ff6a3d', display:'block' }} />
                    </span>
                    <div>
                        <div style={{ fontSize:'14px', fontWeight:600, color:'#ff6a3d', marginBottom:'2px' }}>QR Code Client</div>
                        <div style={{ fontSize:'12px', color:'#6b7280' }}>QR personnalisé pour client fidèle</div>
                    </div>
                </label>
            </ModalWrapper>
        );
    }

    /* ── Type 2 : VAD ────────────────────────────────────── */
    if (defaultType === 2) {
        return (
            <>
                <div onClick={onClose} style={{ position:'fixed', inset:0, backgroundColor:'rgba(0,0,0,0.35)', backdropFilter:'blur(4px)', zIndex:1040 }} />
                <div style={{ position:'fixed', top:'50%', left:'50%', transform:'translate(-50%,-50%)', width:'480px', maxWidth:'94vw', backgroundColor:'#fff', borderRadius:'20px', boxShadow:'0 20px 60px rgba(0,0,0,0.18)', zIndex:1050, overflow:'hidden' }}>
                    <form onSubmit={handleSubmit}>
                        {/* Header */}
                        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'28px 28px 20px 28px', borderBottom:'1px solid #f3f4f6' }}>
                            <h5 style={{ margin:0, fontSize:'20px', fontWeight:700, color:'#111827' }}>Ajouter</h5>
                            <button type="button" onClick={onClose} style={{ background:'none', border:'none', fontSize:'22px', color:'#9ca3af', cursor:'pointer', lineHeight:1, padding:0 }}>×</button>
                        </div>
                        {/* Body */}
                        <div style={{ padding:'24px 28px' }}>
                            {/* Compteur */}
                            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'24px' }}>
                                <label style={{ fontSize:'14px', color:'#374151', fontWeight:400, margin:0 }}>Nombre de QR VAD</label>
                                <div style={{ display:'flex', alignItems:'center' }}>
                                    <button type="button" onClick={() => setNbTables(Math.max(1, nbTables-1))} style={{ width:'40px', height:'40px', border:'1px solid #e5e7eb', borderRadius:'8px 0 0 8px', background:'#fff', color:'#374151', fontSize:'18px', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>−</button>
                                    <div style={{ width:'48px', height:'40px', border:'1px solid #e5e7eb', borderLeft:'none', borderRight:'none', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:600, fontSize:'16px', color:'#111827' }}>{nbTables}</div>
                                    <button type="button" onClick={() => setNbTables(nbTables+1)} style={{ width:'40px', height:'40px', border:'1px solid #e5e7eb', borderRadius:'0 8px 8px 0', background:'#fff', color:'#374151', fontSize:'18px', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>+</button>
                                </div>
                            </div>
                            {/* Préfixe fixe */}
                            <div>
                                <label style={{ display:'block', fontSize:'11px', fontWeight:700, letterSpacing:'0.08em', color:'#374151', marginBottom:'8px', textTransform:'uppercase' }}>Préfixe</label>
                                <input type="text" value="VAD" readOnly style={{ width:'100%', height:'48px', border:'1px solid #e5e7eb', borderRadius:'10px', fontSize:'15px', color:'#6b7280', padding:'0 14px', backgroundColor:'#f9fafb', cursor:'default', outline:'none' }} />
                            </div>
                        </div>
                        {/* Footer */}
                        <div style={{ padding:'0 28px 28px 28px', display:'flex', flexDirection:'column', gap:'10px' }}>
                            <button type="submit" disabled={loading} style={{ width:'100%', height:'52px', backgroundColor:'#ff6b35', border:'none', borderRadius:'12px', color:'#fff', fontWeight:700, fontSize:'15px', cursor:loading?'not-allowed':'pointer', opacity:loading?0.7:1, display:'flex', alignItems:'center', justifyContent:'center', gap:'8px', transition:'background 0.15s' }}>
                                {loading && <span className="spinner-border spinner-border-sm" style={{ width:'14px', height:'14px', borderWidth:'2px' }} />}
                                Ajouter
                            </button>
                            <button type="button" onClick={onClose} style={{ width:'100%', height:'52px', backgroundColor:'#fff', border:'1px solid #e5e7eb', borderRadius:'12px', color:'#374151', fontWeight:500, fontSize:'15px', cursor:'pointer', transition:'background 0.15s' }}>Annuler</button>
                        </div>
                    </form>
                </div>
            </>
        );
    }

    /* ── Autres types : bottom drawer original ──────────── */
    return (
        <>
            {/* Backdrop */}
            {show && (
                <div
                    onClick={onClose}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.4)',
                        zIndex: 1040,
                        opacity: show ? 1 : 0,
                        transition: 'opacity 0.3s ease'
                    }}
                />
            )}

            {/* Bottom Drawer */}
            <div
                style={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    backgroundColor: '#fff',
                    borderRadius: '20px 20px 0 0',
                    boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.15)',
                    zIndex: 1050,
                    transform: show ? 'translateY(0)' : 'translateY(100%)',
                    transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    maxHeight: '90vh',
                    overflowY: 'auto'
                }}
            >
                <form onSubmit={handleSubmit}>
                    {/* Header */}
                    <div
                        style={{
                            padding: '24px 24px 16px 24px',
                            position: 'sticky',
                            top: 0,
                            backgroundColor: '#fff',
                            borderRadius: '20px 20px 0 0',
                            zIndex: 10
                        }}
                    >
                        {/* Drag Handle */}
                        <div
                            style={{
                                width: '40px',
                                height: '4px',
                                backgroundColor: '#e5e7eb',
                                borderRadius: '2px',
                                margin: '0 auto 16px auto'
                            }}
                        />

                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h5
                                style={{
                                    fontSize: '18px',
                                    fontWeight: 600,
                                    color: '#111827',
                                    margin: 0,
                                    lineHeight: '28px'
                                }}
                            >
                                {editMode ? "Modifier la table" : "Ajouter des tables"}
                            </h5>
                            <button
                                type="button"
                                onClick={onClose}
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    fontSize: '28px',
                                    lineHeight: '1',
                                    color: '#6b7280',
                                    cursor: 'pointer',
                                    padding: '4px',
                                    width: '32px',
                                    height: '32px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '6px',
                                    transition: 'background-color 0.15s'
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#f3f4f6'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                            >
                                ×
                            </button>
                        </div>
                    </div>

                    {/* Body */}
                    <div style={{ padding: '0 24px 24px 24px' }}>
                        {/* Number of tables (only if not editing) */}
                        {!editMode && (
                            <div style={{ marginBottom: '24px' }}>
                                <label
                                    className="form-label d-block"
                                    style={{
                                        fontSize: '13px',
                                        fontWeight: 500,
                                        color: '#374151',
                                        marginBottom: '8px',
                                        lineHeight: '20px'
                                    }}
                                >
                                    Combien de tables souhaitez-vous créer ?
                                </label>
                                <div className="d-flex align-items-center" style={{ gap: '12px' }}>
                                    <button
                                        type="button"
                                        onClick={() => setNbTables(Math.max(1, nbTables - 1))}
                                        style={{
                                            width: '40px',
                                            height: '40px',
                                            border: '1px solid #d1d5db',
                                            borderRadius: '8px',
                                            background: '#fff',
                                            color: '#374151',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            transition: 'all 0.15s',
                                            fontSize: '18px',
                                            fontWeight: 400,
                                            padding: 0
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.borderColor = '#9ca3af';
                                            e.target.style.backgroundColor = '#f9fafb';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.borderColor = '#d1d5db';
                                            e.target.style.backgroundColor = '#fff';
                                        }}
                                    >
                                        −
                                    </button>
                                    <div
                                        style={{
                                            fontSize: '20px',
                                            fontWeight: 600,
                                            color: '#111827',
                                            minWidth: '40px',
                                            textAlign: 'center',
                                            lineHeight: '28px'
                                        }}
                                    >
                                        {nbTables}
                                    </div>
                                    <button
                                        type="button"
                                        onClick={() => setNbTables(nbTables + 1)}
                                        style={{
                                            width: '40px',
                                            height: '40px',
                                            border: '1px solid #d1d5db',
                                            borderRadius: '8px',
                                            background: '#fff',
                                            color: '#374151',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            transition: 'all 0.15s',
                                            fontSize: '18px',
                                            fontWeight: 400,
                                            padding: 0
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.borderColor = '#9ca3af';
                                            e.target.style.backgroundColor = '#f9fafb';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.borderColor = '#d1d5db';
                                            e.target.style.backgroundColor = '#fff';
                                        }}
                                    >
                                        +
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* Table Name Prefix */}
                        <div style={{ marginBottom: '24px' }}>
                            <label
                                className="form-label d-block"
                                style={{
                                    fontSize: '13px',
                                    fontWeight: 500,
                                    color: '#374151',
                                    marginBottom: '8px',
                                    lineHeight: '20px'
                                }}
                            >
                                {editMode ? "Nom de la table" : "Préfixe des noms de table"}
                            </label>
                            <input
                                type="text"
                                name="prefix_nom"
                                value={formData.prefix_nom}
                                onChange={handleChange}
                                className="form-control"
                                placeholder={editMode ? "Ex : Terrasse 1, VIP, Bar..." : "Ex : Table, VIP, Terrasse..."}
                                style={{
                                    height: '44px',
                                    borderRadius: '8px',
                                    border: '1px solid #d1d5db',
                                    fontSize: '14px',
                                    color: '#111827',
                                    padding: '10px 12px',
                                    transition: 'all 0.15s',
                                    outline: 'none',
                                    width: '100%'
                                }}
                                onFocus={(e) => {
                                    e.target.style.borderColor = '#3b82f6';
                                    e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                                }}
                                onBlur={(e) => {
                                    e.target.style.borderColor = '#d1d5db';
                                    e.target.style.boxShadow = 'none';
                                }}
                            />
                            <small
                                className="text-muted d-block"
                                style={{
                                    fontSize: '12px',
                                    color: '#6b7280',
                                    marginTop: '6px',
                                    lineHeight: '16px'
                                }}
                            >
                                {editMode
                                    ? "Le nom unique de cette table"
                                    : `Vos tables seront nommées : ${formData.prefix_nom}-1, ${formData.prefix_nom}-2, ${formData.prefix_nom}-3...`
                                }
                            </small>
                        </div>

                        {/* Capacity */}
                        {formData.type_table === 1 && (
                            <div style={{ marginBottom: '0' }}>
                                <label
                                    className="form-label d-block"
                                    style={{
                                        fontSize: '13px',
                                        fontWeight: 500,
                                        color: '#374151',
                                        marginBottom: '8px',
                                        lineHeight: '20px'
                                    }}
                                >
                                    Capacité (nombre de places)
                                </label>
                                <div className="d-flex align-items-center" style={{ gap: '12px' }}>
                                    <button
                                        type="button"
                                        onClick={() => setFormData(prev => ({ ...prev, capacit: Math.max(1, prev.capacite - 1) }))}
                                        style={{
                                            width: '40px',
                                            height: '40px',
                                            border: '1px solid #d1d5db',
                                            borderRadius: '8px',
                                            background: '#fff',
                                            color: '#374151',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            transition: 'all 0.15s',
                                            fontSize: '18px',
                                            fontWeight: 400,
                                            padding: 0
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.borderColor = '#9ca3af';
                                            e.target.style.backgroundColor = '#f9fafb';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.borderColor = '#d1d5db';
                                            e.target.style.backgroundColor = '#fff';
                                        }}
                                    >
                                        −
                                    </button>
                                    <div
                                        style={{
                                            fontSize: '20px',
                                            fontWeight: 600,
                                            color: '#111827',
                                            minWidth: '40px',
                                            textAlign: 'center',
                                            lineHeight: '28px'
                                        }}
                                    >
                                        {formData.capacite}
                                    </div>
                                    <button
                                        type="button"
                                        onClick={() => setFormData(prev => ({ ...prev, capacite: prev.capacite + 1 }))}
                                        style={{
                                            width: '40px',
                                            height: '40px',
                                            border: '1px solid #d1d5db',
                                            borderRadius: '8px',
                                            background: '#fff',
                                            color: '#374151',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            transition: 'all 0.15s',
                                            fontSize: '18px',
                                            fontWeight: 400,
                                            padding: 0
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.borderColor = '#9ca3af';
                                            e.target.style.backgroundColor = '#f9fafb';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.borderColor = '#d1d5db';
                                            e.target.style.backgroundColor = '#fff';
                                        }}
                                    >
                                        +
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* Type de table */}
                        <div style={{ marginBottom: '0', marginTop: '24px' }}>
                            <label
                                className="form-label d-block"
                                style={{
                                    fontSize: '13px',
                                    fontWeight: 500,
                                    color: '#374151',
                                    marginBottom: '12px',
                                    lineHeight: '20px'
                                }}
                            >
                                Type de table
                            </label>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                {/* Type 1 - Classique */}
                                <label
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '12px 16px',
                                        border: formData.type_table === 1 ? '2px solid #ff6a3d' : '1px solid #d1d5db',
                                        borderRadius: '8px',
                                        cursor: formData.type_table === 1 ? 'default' : 'not-allowed',
                                        backgroundColor: formData.type_table === 1 ? '#ff6a3d21' : '#ff6a3d21',
                                        opacity: formData.type_table === 1 ? 1 : 0.5,
                                        transition: 'all 0.15s'
                                    }}
                                >
                                    <input
                                        type="radio"
                                        name="type_table"
                                        value="1"
                                        checked={formData.type_table === 1}
                                        disabled={formData.type_table !== 1}
                                        onChange={(e) => setFormData(prev => ({ ...prev, type_table: parseInt(e.target.value) }))}
                                        style={{
                                            marginRight: '12px',
                                            width: '18px',
                                            height: '18px',
                                            cursor: formData.type_table === 1 ? 'default' : 'not-allowed',
                                            accentColor: '#3b82f6'
                                        }}
                                    />
                                    <div style={{ flex: 1 }}>
                                        <div style={{ fontSize: '14px', fontWeight: 600, color: '#111827', marginBottom: '2px' }}>
                                            Classique
                                        </div>
                                        <div style={{ fontSize: '12px', color: '#6b7280' }}>
                                            Table standard pour service en salle
                                        </div>
                                    </div>
                                </label>

                                {/* Type 2 - Livraison */}
                                <label
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '12px 16px',
                                        border: formData.type_table === 2 ? '2px solid #ff6a3d' : '1px solid #d1d5db',
                                        borderRadius: '8px',
                                        cursor: formData.type_table === 2 ? 'default' : 'not-allowed',
                                        backgroundColor: formData.type_table === 2 ? '#ff6a3d21' : '#ff6a3d21',
                                        opacity: formData.type_table === 2 ? 1 : 0.5,
                                        transition: 'all 0.15s'
                                    }}
                                >
                                    <input
                                        type="radio"
                                        name="type_table"
                                        value="2"
                                        checked={formData.type_table === 2}
                                        disabled={formData.type_table !== 2}
                                        onChange={(e) => setFormData(prev => ({ ...prev, type_table: parseInt(e.target.value) }))}
                                        style={{
                                            marginRight: '12px',
                                            width: '18px',
                                            height: '18px',
                                            cursor: formData.type_table === 2 ? 'default' : 'not-allowed',
                                            accentColor: '#3b82f6'
                                        }}
                                    />
                                    <div style={{ flex: 1 }}>
                                        <div style={{ fontSize: '14px', fontWeight: 600, color: '#111827', marginBottom: '2px' }}>
                                            Vente à distance
                                        </div>
                                        <div style={{ fontSize: '12px', color: '#6b7280' }}>
                                            Pour les commandes en livraison
                                        </div>
                                    </div>
                                </label>

                                {/* Type 3 - QR Client */}
                                <label
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '12px 16px',
                                        border: formData.type_table === 3 ? '2px solid #ff6a3d' : '1px solid #d1d5db',
                                        borderRadius: '8px',
                                        cursor: formData.type_table === 3 ? 'default' : 'not-allowed',
                                        backgroundColor: formData.type_table === 3 ? '#ff6a3d21' : '#ff6a3d21',
                                        opacity: formData.type_table === 3 ? 1 : 0.5,
                                        transition: 'all 0.15s'
                                    }}
                                >
                                    <input
                                        type="radio"
                                        name="type_table"
                                        value="3"
                                        checked={formData.type_table === 3}
                                        disabled={formData.type_table !== 3}
                                        onChange={(e) => setFormData(prev => ({ ...prev, type_table: parseInt(e.target.value) }))}
                                        style={{
                                            marginRight: '12px',
                                            width: '18px',
                                            height: '18px',
                                            cursor: formData.type_table === 3 ? 'default' : 'not-allowed',
                                            accentColor: '#3b82f6'
                                        }}
                                    />
                                    <div style={{ flex: 1 }}>
                                        <div style={{ fontSize: '14px', fontWeight: 600, color: '#111827', marginBottom: '2px' }}>
                                            QR Code Client
                                        </div>
                                        <div style={{ fontSize: '12px', color: '#6b7280' }}>
                                            QR personnalisé pour client fidèle
                                        </div>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>

                    {/* Footer */}
                    <div
                        style={{
                            padding: '16px 24px 24px 24px',
                            borderTop: '1px solid #f3f4f6',
                            position: 'sticky',
                            bottom: 0,
                            backgroundColor: '#fff'
                        }}
                    >
                        <div
                            style={{
                                fontSize: '12px',
                                color: '#6b7280',
                                lineHeight: '16px',
                                marginBottom: '12px',
                                textAlign: 'center'
                            }}
                        >
                            Restaurant : <span style={{ fontWeight: 500, color: '#374151' }}>{restaurantName}</span>
                        </div>
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <button
                                type="button"
                                onClick={onClose}
                                style={{
                                    height: '48px',
                                    flex: 1,
                                    backgroundColor: '#fff',
                                    border: '1px solid #d1d5db',
                                    borderRadius: '8px',
                                    color: '#374151',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                    cursor: 'pointer',
                                    transition: 'all 0.15s',
                                    lineHeight: '20px'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = '#f9fafb';
                                    e.target.style.borderColor = '#9ca3af';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = '#fff';
                                    e.target.style.borderColor = '#d1d5db';
                                }}
                            >
                                Annuler
                            </button>
                            <button
                                type="submit"
                                disabled={loading}
                                style={{
                                    height: '48px',
                                    flex: 1,
                                    backgroundColor: '#ff6b35',
                                    border: 'none',
                                    borderRadius: '8px',
                                    color: '#fff',
                                    fontWeight: 600,
                                    fontSize: '14px',
                                    cursor: loading ? 'not-allowed' : 'pointer',
                                    transition: 'all 0.15s',
                                    lineHeight: '20px',
                                    opacity: loading ? 0.7 : 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px'
                                }}
                                onMouseEnter={(e) => {
                                    if (!loading) e.target.style.backgroundColor = '#ff5722';
                                }}
                                onMouseLeave={(e) => {
                                    if (!loading) e.target.style.backgroundColor = '#ff6b35';
                                }}
                            >
                                {loading && (
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        style={{ width: '14px', height: '14px', borderWidth: '2px' }}
                                    />
                                )}
                                {editMode ? "Mettre à jour" : "Créer la table"}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}

AddTables.propTypes = {
    onFormSubmit: PropTypes.func.isRequired,
    show: PropTypes.bool,
    onClose: PropTypes.func,
    editMode: PropTypes.bool,
    TableData: PropTypes.object,
    defaultType: PropTypes.number
};


export default AddTables
